import { z } from 'zod';

/** Standard error envelope returned by the API on any failure. */
export const errorResponseSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    /** Optional structured detail, e.g. flattened Zod validation issues. */
    details: z.unknown().optional(),
  }),
});
export type ErrorResponse = z.infer<typeof errorResponseSchema>;
